/**
 * BriqueChart에서 사용할 Data의 Plotly의 Default 옵션
 */
export default {
  /**
   * BriqueChart에서 사용할 Plotly Data Option의 Default
   *   - Data Option 속성은 Chart Element의 briqueChartData.tracesOriginald에 Series의 Data와 함께 저장된다.
   *   - Data Option 속성을 개별 화면별로 다르게 설정하려면 newPlot() 호출시 oTraces에 Data Option을 지정하여 호출하면 된다.
   */
  defaultDataOption: {

  },

  /**
   * Data의 Option 초기화
   * @param {Array} oTraces 호출하는 측의 Data
   * @param {Object} defaultDataOption 호출하는 측에서 설정하지 않아도 적용할 기본 Data Option
   * * @param {Object} layout Plotly의 Layout
   * * @param {Object} briqueChartData BriqueChart에서 데이터 관련하여 저장한 값
   */
  initDataOption (oTraces, defaultDataOption, layout, briqueChartData) {
    let keys = Object.keys(defaultDataOption)

    let barCount = 0
    for (let trace of oTraces) {
      for (let key of keys) {
        if (!_.isObject(defaultDataOption[key])) {
          trace[key] = defaultDataOption[key]
        } else {
          trace[key] = _.merge({}, defaultDataOption[key], trace[key])
        }
      }

      // Bar의 시작 위치 설정
      // let orientation = trace.orientation ?? defaultDataOption.orientation ?? 'v'
      // trace.base = trace.base ?? ((orientation === 'v') ? briqueChartData.yMinForPad : briqueChartData.xMinForPad)
      // trace.base = -5000
      // console.log(trace.base)

      if (trace.type === 'bar' && layout.bargap === undefined) {
        if (barCount > 0 && (layout.barmode || 'group') !== 'group') { // stack, overlay, relative일때는 하나의 바에 Series가 다 표시되므로 카운트 하지 않음
          continue
        }

        barCount += trace.x?.length || 0
      }
    }

    if (layout.bargap === undefined && barCount > 0 && barCount < 10) {
      layout.bargap = (10 - barCount) / 10 // Point 사이의 간격
    }

    return oTraces
  }
}
